// @ts-nocheck
import { Component } from "@theme/component";
import "./swiper-bundle.min.js";

class RfMediaSwiper extends Component {
  /** @type {any} */
  gallerySwiper = null;

  /** @type {any} */
  thumbsSwiper = null;

  /** @type {boolean} */
  _hoverBound = false;

  /** @type {number | null} */
  _hoverRepeatTimer = null;

  /** @type {ResizeObserver | null} */
  _resizeObserver = null;

  /** @type {boolean} */
  _transitionHandlerBound = false;

  /** @type {number | null} */
  _lastThumbsTranslate = null;

  /** @type {boolean} */
  _isHovering = false;

  connectedCallback() {
    super.connectedCallback();

    // 存储待处理的 variant 事件数据
    this._pendingVariantData = null;

    window.addEventListener("variant-param", (e) => {
      // 使用 detail 数据来跳转到对应的图片
      if (e.detail) {
        if (this.gallerySwiper) {
          // Swiper 已经初始化，直接处理
          this.handleVariantChange(e.detail);
        } else {
          // Swiper 还未初始化，保存数据等待初始化完成后处理
          this._pendingVariantData = e.detail;
        }
      }
    });

    const initSwiper = () => {
      if (
        typeof Swiper !== "undefined" &&
        this.refs.thumbs &&
        this.refs.gallery
      ) {
        this.thumbsSwiper = new Swiper(this.refs.thumbs, {
          slidesPerView: "auto",
          watchSlidesProgress: true,
          slideToClickedSlide: true,
          freeMode: { enabled: true, sticky: true },
          // 让尺寸变化时自动更新
          observer: true,
          observeParents: true,
          observeSlideChildren: true,
          // 居中当前激活项，避免重置后偏移
          centeredSlides: true,
          centeredSlidesBounds: true,
          watchSlidesVisibility: true,
          watchOverflow: true,
        });

        this.gallerySwiper = new Swiper(this.refs.gallery, {
          spaceBetween: 20,
          preloadImages: false,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          thumbs: {
            swiper: this.thumbsSwiper,
            autoScrollOffset: 1,
          },
          on: {
            slideChange: () => {
              this.loadCurrentSlideImage();
            },
            init: () => {
              this.loadCurrentSlideImage();
            },
          },
        });

        // 初始化时也更新一次
        const pageDiv = this.refs.page;
        if (pageDiv) {
          const currentIndex = this.gallerySwiper.activeIndex + 1;
          const total = this.gallerySwiper.slides.length;
          pageDiv.innerHTML = `${currentIndex} / ${total}`;
        }
        this.gallerySwiper.on("slideChange", () => {
          // 仅在 hover 时才尝试把缩略图滚动到视野，避免非 hover 状态下的移动
          if (this._isHovering) {
            this.thumbsSwiper.slideTo(this.gallerySwiper.activeIndex);
          }
          const currentIndex = this.gallerySwiper.activeIndex + 1;
          const total = this.gallerySwiper.slides.length;
          const pageDiv = this.refs.page;
          if (pageDiv) {
            pageDiv.innerHTML = `${currentIndex} / ${total}`;
          }
        });

        this.classList.remove("swiper-loading");

        // 检查是否有待处理的 variant 数据
        if (this._pendingVariantData) {
          this.handleVariantChange(this._pendingVariantData);
          this._pendingVariantData = null;
        }

        this.thumbsSwiper.on("click", (swiper, event) => {
          const clickedSlide = event.target.closest(".swiper-slide");
          if (clickedSlide) {
            const clickedIndex = Array.from(
              clickedSlide.parentNode.children
            ).indexOf(clickedSlide);
            this.gallerySwiper.slideTo(clickedIndex);
          }
        });

        this.startThumbAnimation();

        // Hover 时确保激活缩略图进入视野，并在尺寸动画期间多次校准
        if (!this._hoverBound) {
          this._hoverBound = true;
          const onEnter = () => {
            this._isHovering = true;
            if (this.thumbsSwiper) {
              try {
                // 启用居中与粘性，更新后再恢复位移
                this.thumbsSwiper.params.centeredSlides = true;
                this.thumbsSwiper.params.centeredSlidesBounds = true;
                if (
                  this.thumbsSwiper.params.freeMode &&
                  typeof this.thumbsSwiper.params.freeMode === "object"
                ) {
                  this.thumbsSwiper.params.freeMode.sticky = true;
                }
                this.thumbsSwiper.update();
                if (this._lastThumbsTranslate !== null) {
                  this.thumbsSwiper.setTransition(0);
                  this.thumbsSwiper.setTranslate(this._lastThumbsTranslate);
                  this.thumbsSwiper.updateProgress();
                }
              } catch (e) {}
            }
            this.startEnsureActiveRepeat();
          };
          const onLeave = () => {
            this._isHovering = false;
            if (this.thumbsSwiper) {
              try {
                // 记录当前位移
                this._lastThumbsTranslate = this.thumbsSwiper.getTranslate();
                // 关闭居中与粘性，更新后维持当前位置，避免从左向右移动
                this.thumbsSwiper.params.centeredSlides = false;
                this.thumbsSwiper.params.centeredSlidesBounds = false;
                if (
                  this.thumbsSwiper.params.freeMode &&
                  typeof this.thumbsSwiper.params.freeMode === "object"
                ) {
                  this.thumbsSwiper.params.freeMode.sticky = false;
                }
                this.thumbsSwiper.update();
                if (this._lastThumbsTranslate != null) {
                  this.thumbsSwiper.setTransition(0);
                  this.thumbsSwiper.setTranslate(this._lastThumbsTranslate);
                  this.thumbsSwiper.updateProgress();
                }
              } catch (e) {}
            }
            this.stopEnsureActiveRepeat();
          };
          this.addEventListener("mouseenter", onEnter);
          this.addEventListener("mouseleave", onLeave);
          if (this.refs.thumbs) {
            this.refs.thumbs.addEventListener("mouseenter", onEnter);
            this.refs.thumbs.addEventListener("mouseleave", onLeave);
          }
        }

        // 监听尺寸/布局变化与过渡结束，随时重新校准（仅在 hover 时）
        this.setupThumbsVisibilityGuards();
      } else {
        requestAnimationFrame(initSwiper);
      }
    };

    // 延迟到下一帧执行，确保DOM ready
    requestAnimationFrame(initSwiper);
  }

  // 启动缩略图渐入动画
  startThumbAnimation() {
    const thumbSlides = this.refs.thumbs.querySelectorAll(".swiper-slide");
    thumbSlides.forEach((slide, index) => {
      setTimeout(() => {
        slide.classList.remove("opacity-0", "translate-x-4");
        slide.classList.add("thumb-slide-animate");
      }, index * 30);
    });
  }

  loadCurrentSlideImage() {
    if (!this.gallerySwiper) return;

    const currentSlide =
      this.gallerySwiper.slides[this.gallerySwiper.activeIndex];
    if (!currentSlide) return;

    const lazyImg = currentSlide.querySelector("img[data-src]");
    if (lazyImg) {
      const preloader = currentSlide.querySelector(".swiper-lazy-preloader");

      lazyImg.onload = () => {
        lazyImg.classList.remove("swiper-lazy");
        if (preloader) preloader.remove();
      };

      lazyImg.onerror = () => {
        if (preloader) preloader.remove();
      };

      lazyImg.src = lazyImg.getAttribute("data-src");
      lazyImg.removeAttribute("data-src");
    }
  }

  ensureActiveThumbVisible() {
    if (!this.gallerySwiper || !this.thumbsSwiper) return;
    // 不在 hover 状态下不进行对齐，避免从左向右移动
    if (!this._isHovering) return;
    const activeIndex = this.gallerySwiper.activeIndex || 0;
    try {
      // 在尺寸/布局变化后更新实例再对齐
      this.thumbsSwiper.updateSlides();
      this.thumbsSwiper.updateAutoHeight();
      this.thumbsSwiper.updateSize();
      this.thumbsSwiper.updateProgress();
    } catch (e) {}
    this.thumbsSwiper.slideTo(activeIndex, 0);
  }

  startEnsureActiveRepeat() {
    // 进入时立刻对齐，然后在短时间内多次对齐，避免因 hover 尺寸动画导致偏移
    this.stopEnsureActiveRepeat();
    let count = 0;
    const maxCount = 12; // 加长校准时长，适配更慢的过渡/低端设备
    const tick = () => {
      this.ensureActiveThumbVisible();
      count++;
      if (count >= maxCount && this._hoverRepeatTimer) {
        clearInterval(this._hoverRepeatTimer);
        this._hoverRepeatTimer = null;
      }
    };
    tick();
    this._hoverRepeatTimer = setInterval(tick, 80);
  }

  stopEnsureActiveRepeat() {
    if (this._hoverRepeatTimer) {
      clearInterval(this._hoverRepeatTimer);
      this._hoverRepeatTimer = null;
    }
  }

  setupThumbsVisibilityGuards() {
    // ResizeObserver：当缩略图容器或包裹层尺寸变化时校准（仅在 hover 时）
    if (typeof ResizeObserver !== "undefined" && !this._resizeObserver) {
      this._resizeObserver = new ResizeObserver(() => {
        if (!this._isHovering) return;
        this.ensureActiveThumbVisible();
      });
      this._resizeObserver.observe(this.refs.thumbs);
      const wrapper = this.refs.thumbs.querySelector(".swiper-wrapper");
      if (wrapper) this._resizeObserver.observe(wrapper);
    }

    // transitionend：当缩略图宽高/transform 过渡结束时校准（仅在 hover 时）
    if (!this._transitionHandlerBound && this.refs.thumbs) {
      this._transitionHandlerBound = true;
      const handler = (e) => {
        if (!this._isHovering) return;
        const target = e.target;
        if (!target || !target.classList) return;
        if (target.classList.contains("swiper-slide")) {
          this.ensureActiveThumbVisible();
        }
      };
      this.refs.thumbs.addEventListener("transitionend", handler, true);
    }
  }

  /**
   * 处理变体变化，跳转到对应的图片
   * @param {string} variantName - 变体名称
   */
  handleVariantChange(variantName) {
    if (!this.gallerySwiper) return;

    const imgs = this.querySelectorAll(".gallery-swiper img");
    const imageIndex = Array.from(imgs).findIndex(
      (img) => img.alt === variantName
    );

    if (imageIndex > -1) {
      this.jumpTo(imageIndex);
    }
  }

  jumpTo(index) {
    this.gallerySwiper.slideTo(index);
    // 非 hover 状态下不滚动缩略图，避免触发意外位移
    if (this._isHovering) {
      this.thumbsSwiper.slideTo(index);
    }
  }
}

if (!customElements.get("rf-media-swiper")) {
  customElements.define("rf-media-swiper", RfMediaSwiper);
}
